import { useEffect, useRef } from "react"

const isTypingTarget = (target: EventTarget | null) => {
    if (!(target instanceof HTMLElement)) {
        return false
    }
    return target.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)
}

/**
 * Calls `callback` when `Shift + key` is pressed, except while typing in a field.
 */
export function useShiftKeyShortcut(key: string, callback: () => void, enabled = true) {
    const callbackRef = useRef(callback)
    callbackRef.current = callback

    useEffect(() => {
        if (!enabled) {
            return
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (
                !event.shiftKey || event.ctrlKey || event.metaKey || event.altKey || event.repeat
                || event.key.toLowerCase() !== key.toLowerCase()
                || isTypingTarget(event.target)
            ) {
                return
            }
            event.preventDefault()
            callbackRef.current()
        }

        window.addEventListener("keydown", handleKeyDown)
        return () => window.removeEventListener("keydown", handleKeyDown)
    }, [key, enabled])
}
